import React, { useState } from 'react';

const numList = [1, 2, 3, 5, 7, 9, 11, 13, 15, 17, 19];

const LinearSearch = (x, array) => {
    for (let i = 0; i < array.length; i++) {
        if (x === array[i]) {
            return array[i];
        }
    }
    return "not found"
}

// cant seem to update search param from input

const Result = () => {
    var [search] = useState(5);

    return (<div>
        {/* <input value={search} onChange={e => setSearch(e.target.value)} /> */}
        <p>Result:{LinearSearch(search, numList)}</p>
    </div>)
}

export default Result;